<template>
  <div
    @click="onCategoryClick"
    :id="`${category.anchor}-id`"
    class="food-category"
    :class="{ 'pda-category': isPda , 'smaller-pda-category': isPda && $screen.width < 1397, 'selected-desktop-pda-category': isPda && category.isActive}"
    :style="isPda && category.bgColor!=null && category.bgColor!='#ffffff' ? { backgroundColor: category.bgColor, color: category.textColor == null ? '#141414': '#f7f7f7'} : {}"
  >
    <div
      :class="{ selectedCategory: category.isActive && !isPda, selectedPdaCategoryNoBg: category.isActive && isPda && (category.bgColor==null || category.bgColor=='#ffffff'), selectedPdaCategoryWithBg: category.isActive && isPda && category.bgColor!=null && category.bgColor!='#ffffff' }"
      id="category"
      :style="isPda && category.bgColor!=null && category.bgColor!='#ffffff' && category.textColor==null ? { fontWeight: '700'} : {}"
    >
      <p>{{ getCategoryName(category)}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "FoodCategory",
  components: {},
  computed: {
    areMobileCategoriesOpen() {
      return this.$store.getters.getAreMobileCategoriesOpen;
    },

    language() {
      return this.$store.getters.getLanguage;
    },

    selectedExtraLanguage() {
      return this.$store.getters.getSelectedExtraLanguage;
    }
  },

  data() {
    return {};
  },
  props: ["category", "isPda"],
  methods: {
    getCategoryName(category) {
      if (this.selectedExtraLanguage != null && category.names.translation[this.selectedExtraLanguage] && category.names.translation[this.selectedExtraLanguage].name != null && category.names.translation[this.selectedExtraLanguage].name.trim().length != 0) {
        return category.names.translation[this.selectedExtraLanguage].name;
      }
      return category.names.translation[this.language].name;
    },
    onCategoryClick: function () {
      const yOffset = -50;
      const y =
        document.getElementById(this.category.anchor).getBoundingClientRect()
          .top +
        window.pageYOffset +
        yOffset;

      window.scrollTo({ top: y });

      if (!this.category.isActive) {
        this.$store.dispatch("goToCategory", this.category);
      }
    },
  },
};
</script>

<style scoped>
.food-category {
  width: 99%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  margin-bottom: 1vh;
  color: rgb(88, 88, 88);
  font-size: 15px;
  font-weight: 200;
  margin: 4% 0% 3% 2%;
  padding-top: 5%;
  padding-bottom: 5%;
  padding-right: 2px;
  padding-left: 2px;
  background-color: #f3f3f3;
  border-radius: 10px;
}

.pda-category {
  margin: 0% 0% 8px 2%;
  background-color: #dcdcdc;
  color: #ececec;
  background-color: #003340ea;
  padding-top: 4%;
  padding-bottom: 4%;
  width: 98%;
  min-height: 38px !important;
}

.smaller-pda-category {
  font-size: 13px;
  min-height: 30px !important;
}

p {
  display: inline;
}

#category {
  height: 100%;
  font-weight: 600;
  margin-right: 10px;
}

.selectedCategory {
  color: #ed5005;
  font-size: 16px;
  font-weight: 800 !important;
}

.selected-desktop-pda-category {
  width: 104%;
  border: 2px solid #065367;
  box-shadow: 0 0 8px 1px #ff641d;
}

.selectedPdaCategoryNoBg {
  color: #ff641d;
  font-size: 17px;
  font-weight: 800 !important;
}

.selectedPdaCategoryWithBg {
  font-size: 17px;
  font-weight: 800 !important;
}

.redBorder {
  border: 1px solid #198b4a;
  box-shadow: 2px 2px 4px rgba(93, 92, 99, 0.16),
    2px 2px 4px rgba(93, 92, 99, 0.23);
}

@media screen and (max-width: 1397px) {
  .selectedPdaCategoryNoBg {
    font-size: 15px;
  }

  .selectedPdaCategoryWithBg {
    font-size: 15px;
  }
}

@media screen and (max-width: 800px) {
  .food-category {
    width: 80%;
    font-size: 15px;
    margin-right: 10vw;
    margin-bottom: -3%;
  }

  #category {
    margin-left: 5vw;
  }
}
</style>



